import isEmpty from 'lodash/isEmpty';
import dayjs from 'dayjs';
import { immutableField } from '@/lib/immutableField';
import { targetValidationNullable } from '@/const/targetValidationNullable';
import { errorMessages } from '@/const/dateValidator';
import * as Yup from 'yup';



export const makeValidationSchema = (collectionConfig, originalCollection = {}, dynamicData = {}) => Yup.lazy((values) => Yup.object().shape({
  title: Yup.string()
    .nullable()
    .min(3, 'Min 3 symbols required')
    .max(2000, 'Max 2000 symbols required'),
  template_id: Yup.string().required('Required to specify template'),
  use_utc_zero_time: Yup.bool(),
  is_published: Yup.bool().nullable(),
  categories: immutableField(originalCollection.categories.data.map((category) => category.id)),
  image_type: immutableField(originalCollection.image_type),
  released_at: Yup.date()
    .when('is_published', {
      is: false,
      then: (schema) => schema.nullable(),
      otherwise: (schema) => schema.required(errorMessages.releasedAt.required),
    })
    .before(values?.released_to, errorMessages.releasedAt.before),
  ...collectionConfig?.release_range && {
    released_to: Yup.date().nullable()
      .after(values?.released_at, errorMessages.releasedTo.after),
  },
  target: Yup.object().shape(targetValidationNullable(values)),
  ...dynamicData,
}));

export const isOutImageOfReleaseDates = (releasedImages, initialValues, releasedAt, releasedTo) => {
  return releasedImages.some((image) => {
    const outOfRangeArr = [];

    if (!isEmpty(releasedAt)) {
      outOfRangeArr.push(!image?.published_at || (dayjs(image?.published_at).isBefore(dayjs(releasedAt))));
    }

    if (!isEmpty(releasedTo)) {
      if (!isEmpty(image?.published_to)) {
        outOfRangeArr.push(dayjs(image?.published_to).isAfter(dayjs(releasedTo)));
      }

      if (isEmpty(image?.published_to) && !dayjs(initialValues.released_to).isSame(dayjs(releasedTo))) {
        outOfRangeArr.push(true);
      }
    }

    if ((isEmpty(initialValues.released_to) && isEmpty(image?.published_to) && !isEmpty(releasedTo)) ||
      (!isEmpty(initialValues.released_to) && !isEmpty(image?.published_to) && isEmpty(releasedTo))) {
      outOfRangeArr.push(true);
    }

    return outOfRangeArr.includes(true);
  });
};
